import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoTesla = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 154 48"
    {...props}
  >
    <g
      fill="#5E5E5E"
      clipPath="url(#Logo_Tesla_svg__a)"
    >
      <path
        d="M131.646 22.936v12.052h3.852v-8.034h14.089v8.034h3.852V22.936zm3.412-3.907h14.859c2.091-.385 3.577-2.256 4.017-4.017h-22.893c.44 1.76 1.981 3.577 4.017 4.017m-15.134 15.96c1.926-.826 2.972-2.257 3.412-3.908h-17.335V15.067h-3.907v19.921zM73.202 18.973H86.96c2.091-.605 3.797-2.201 4.238-3.907H69.405v11.777h17.83v4.127H73.257c-2.201.605-4.072 2.091-5.008 4.017h22.839V22.936h-17.83zm-33.9.055h14.86c2.09-.385 3.631-2.256 4.016-4.017H35.23c.44 1.76 1.981 3.577 4.072 4.017m0 7.87h14.86c2.09-.386 3.631-2.257 4.016-4.018H35.23c.44 1.761 1.981 3.577 4.072 4.018m0 8.09h14.86c2.09-.386 3.631-2.257 4.016-4.018H35.23c.44 1.761 1.981 3.632 4.072 4.017M.615 15.067c.44 1.76 1.981 3.522 4.017 3.962h6.274l.33.11v15.794h3.907V19.14l.33-.11h6.274c2.091-.55 3.577-2.201 4.018-3.962v-.055z" />
    </g>
    <defs>
      <clipPath id="Logo_Tesla_svg__a">
        <path
          fill="#fff"
          d="M.615 0h153v48h-153z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoTesla;
